module.exports = __webpack_public_path__ + "static/img/unrecognized.317e7db1.png";